import React, { Component } from 'react';

import InlineEditHousingStatus from './Address/HousingStatus';
import InlineEditMoveInDate from './Address/MoveInDate';

class IncomeExpenses extends Component {
  render() {
    return (
      <div>
        <h3>Address</h3>
        <p>Your card will be mailed to your mailing address</p>
        <div className="static-field-container">
          {this.props.children}
          <InlineEditHousingStatus {...this.props.personalInfo}  {...this.props} />
          <InlineEditMoveInDate {...this.props.personalInfo} {...this.props} />
        </div>
      </div>);
  }
}

export default IncomeExpenses;


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Address.js